import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CustomInput from './CustomInput';

export const validateRangeNumber = (value, min, max, required = true) => {
  const numValue = parseInt(value, 10);

  if (value === '' || value === null || value === undefined) {
    return required ? 'Please enter a value' : '';
  }

  if (isNaN(numValue)) {
    return 'Please enter a valid number';
  }

  if (numValue < min || numValue > max) {
    return `Value must be between ${min} and ${max}`;
  }

  return '';
};

const getMaxDigits = (max) => {
  return Math.abs(max).toString().length;
};

const RangeNumberInput = ({
  value,
  onChange,
  min,
  max,
  required = true,
  id = 'range-number-input',
  formControlProps = {}
}) => {
  const maxDigits = getMaxDigits(max);

  const [validationError, setValidationError] = useState(() =>
    validateRangeNumber(value, min, max, required)
  );

  useEffect(() => {
    const error = validateRangeNumber(value, min, max, required);
    setValidationError(error);
  }, [value, min, max, required]);

  const isNumericKey = (key) => {
    return /^[0-9]$/.test(key);
  };

  const handleChange = (newValue) => {
    const error = validateRangeNumber(newValue, min, max, required);
    setValidationError(error);
    onChange(newValue);
  };

  const handleKeyPress = (e) => {
    if (e.target.value.length >= maxDigits || !isNumericKey(e.key)) {
      e.preventDefault();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const text = e.clipboardData.getData('text');
    const num = parseInt(text, 10);

    if (!isNaN(num) && num >= min && num <= max) {
      handleChange(text);
    }
  };

  return (
    <CustomInput
      id={id}
      error={!!validationError}
      helperText={validationError || false}
      formControlProps={formControlProps}
      inputProps={{
        type: 'number',
        value: value,
        min: min,
        max: max,
        onChange: (e) => handleChange(e.target.value),
        onKeyPress: handleKeyPress,
        onPaste: handlePaste,
        autoComplete: 'off',
      }}
    />
  );
};

RangeNumberInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  required: PropTypes.bool,
  id: PropTypes.string,
  formControlProps: PropTypes.object,
};

export default RangeNumberInput;
